import { getCategoryHref } from '../../utils/common/category';
import { SOCIAL_MEDIA_POST_TITLE_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'socialMediaPostTitleGeneratorType',
      analyticsName: 'social_media_post_title_type',
      textLabel: 'Generate titles for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: SOCIAL_MEDIA_POST_TITLE_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'LandingPage',
        value: getCategoryHref(SOCIAL_MEDIA_POST_TITLE_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'socialMediaPostTitleGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'socialMediaPost_titles_generator',
      placeholder: 'Try "Facebook post about weekend getaway in Berlin"',
      textLabel: 'Describe the social media post',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: SOCIAL_MEDIA_POST_TITLE_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
